<template>
  <div class="md-layout-item md-size-95">
    <label class="control-label">{{label}}</label>
    <div class="input-group">
      <input
        :type="type"
        :name="name"
        :placeholder="placeholder"
        :value="value"
        class="form-control"
        @input="updateValue"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
        @keyup="keyup"
      />
      <span class="input-group-btn">
        <button class="btn btn-primary btn-lg" @click="click">次へ</button>
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TextField',
    props: {
      value: {},
      label: { type: String },
      name: { type: String, require: true },
      type: { type: String, default: 'text' },
      placeholder: { type: String },
    },
    methods: {
      updateValue(e) {
        this.$emit('input', e.target.value);
        this.$emit('change', e.target.value);
      },
      click() {
        this.$emit('click');
      },
      keyup(e) {
        this.$emit('keyup', e);
      },
    },
  };
</script>

<style  lang="scss" scoped>
  .md-layout-item {
    padding-top: 10%;
    label.control-label {
      display: block;
      text-align: left;
      font-size: 1.5rem;

    }

    input.form-control {
      border: 1px solid #ccc;
      border-radius: 4px;
      width: 100%;
      font-size: 2rem;
      padding: 5px 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/TextField.vue?36cfceca